import { ISelector } from '@omaze/redux';

import { createActiveExperienceSelector } from '../../ActiveExperience.factories';
import {
    IActiveExperienceConfig,
    IActiveExperienceState, IGeolocation,
} from '../../ActiveExperience.state';

export const selectRequiresMailInFame: ISelector<IActiveExperienceState, boolean> =
    createActiveExperienceSelector((state: IActiveExperienceState): boolean => {
        const { countryCode, regionCode }: IGeolocation = state.geoLocation;
        const { fameMailInLocations }: IActiveExperienceConfig = state.config;
        let isCountrySupported: boolean = false;
        let isRegionSupported: boolean = false;

        for (const location of fameMailInLocations) {
            if (typeof location === 'string') {
                if (location === countryCode) {
                    isCountrySupported = true;
                    isRegionSupported = true;
                    break;
                }
            } else if (countryCode in location) {
                isCountrySupported = true;

                if (location[countryCode]?.includes(regionCode)) {
                    isRegionSupported = true;
                    break;
                }
            }
        }

        return isCountrySupported && isRegionSupported;
    });
